module.exports = __webpack_public_path__ + "media/video-bg__265.f32b5332.mp4";